import { RequestAppFormData } from '@/components/app-library/RequestAppModal';

export interface AppIdeaResearchData {
  overview: string;
  core_requirements: string;
  enhanced_features: string;
  citations?: string[];
  relatedQuestions?: string[];
}

export const formatProblemStatementForApi = (formData: RequestAppFormData): string => {
  let statement = `Problem: ${formData.problem}`;
  if (formData.category) statement += `\nCategory: ${formData.category}`;
  if (formData.frequency) statement += `\nFrequency of problem: ${formData.frequency}`;
  if (formData.currentSolution) statement += `\nCurrent solution: ${formData.currentSolution}`;
  if (formData.priority) statement += `\nPriority: ${formData.priority}`;
  if (formData.sharing) statement += `\nSharing preference: ${formData.sharing}`;
  if (formData.platform) statement += `\nPlatform: ${formData.platform}`;
  if (formData.additionalDetails) statement += `\nAdditional details: ${formData.additionalDetails}`;
  return statement;
};

export const parseResearchResponse = (content: string): AppIdeaResearchData => {
  const sections = content.split(/^## /m).filter(section => section.trim());
  
  let overview = '';
  let core_requirements = '';
  let enhanced_features = '';
  
  sections.forEach(section => {
    const lines = section.split('\n');
    const title = lines[0].toLowerCase().trim();
    const content = lines.slice(1).join('\n').trim();
    
    if (title.includes('overview')) {
      overview = content;
    } else if (title.includes('requirements') || title.includes('core')) {
      core_requirements = content;
    } else if (title.includes('features') || title.includes('enhanced')) {
      enhanced_features = content;
    }
  });

  return {
    overview,
    core_requirements,
    enhanced_features
  };
};
